export default "__VITE_ASSET__CePPWt29__"